import transpose from "./asset_urls.json";
const assetPath = (url) => {
  Object.keys(transpose).forEach((oldPath) => {
    url = url.replace(oldPath, transpose[oldPath]);
  });
  return url;
};
export default assetPath;
